export default "__VITE_ASSET__D9IS3jwB__"